// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"6fc96256","787":"a5994662"}[chunkId] + ".chunk.js";
};